// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1thB_","content":"LoadingAlert_content__16xQy"};